// Vstup do Lama Klubu — jen mimo směnu (Home bez směny / po směně).
// Ukazuje počet připravených balíčků; tahá overview potichu (žádný spinner).

import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { api } from "../lib/api";
import { LamaMark } from "./LamaMark";

export function LamaEntry() {
  const history = useHistory();
  const { data } = useQuery({
    queryKey: ["mobile", "lamy"],
    queryFn: api.lamy.overview,
    staleTime: 60_000,
    retry: 1,
  });

  // Server-side flag: dokud dispečink Lama Klub nezapne, tlačítko neexistuje.
  if (!data?.enabled) return null;

  const packs = data.packs_available;
  return (
    <button className="lk-entry" onClick={() => history.push("/lamy")}>
      <LamaMark />
      <span>
        <b>Lama Klub</b>
        <small>
          {packs > 0
            ? "Máš nerozbalené balíčky!"
            : `${Math.ceil(data.km_to_next)} km do dalšího balíčku`}
        </small>
      </span>
      {packs > 0 && (
        <span className="lk-pill">{packs === 1 ? "1 balíček" : packs <= 4 ? `${packs} balíčky` : `${packs} balíčků`}</span>
      )}
    </button>
  );
}
